import React, { FC, useCallback, useState } from 'react';
import { Typography } from '@material-ui/core';
import BubbleTooltip from 'src/components/BubbleTooltip/BubbleTooltip';
const bubbleTooltipContent = (
  <>
    <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
      Lernova 2025 inkijken
    </Typography>
    <Typography variant="subtitle2">
      Deze demonstratie-versie toont de{' '}
      <strong>lesmethodes zoals ze eruitzien in schooljaar 2025-26.</strong>
    </Typography>
    <Typography variant="subtitle2">
      Sommige functies zijn uitgeschakeld om de overzichtelijkheid te bewaren.
    </Typography>
  </>
);

const AppBarPopoverDemo: FC = () => {
  const [showDemoInfo, setShowDemoInfo] = useState<boolean>(false);

  const handleShowMessage = useCallback((state: boolean) => {
    setShowDemoInfo(state);
  }, []);

  return (
    <div
      style={{ position: 'relative' }}
      onClick={() => handleShowMessage(!showDemoInfo)}
      onMouseEnter={() => handleShowMessage(true)}
      onMouseLeave={() => handleShowMessage(false)}
    >
      <Typography color="primary" style={{ cursor: 'pointer' }}>
        2025 inkijken
      </Typography>
      <BubbleTooltip show={showDemoInfo}>{bubbleTooltipContent}</BubbleTooltip>
    </div>
  );
};

export default AppBarPopoverDemo;
